import * as ko from 'knockout';

let template = require('raw-loader!../../templates/components/animated_logo.html').default;
ko.components.register('animated-logo', { template: template });
